import { manualDealSliceActions } from '@src/components/OMS/ManualDealTradeView/ManualDealSlice';
import { openManualDealTradeFormThunk } from '@src/components/OMS/ManualDealTradeView/thunks/openManualDealTradeFormThunk';
import { useAppStateDispatch } from '@src/providers/AppStateProvider/AppStateProviderHooks';
import type { OTCDealData } from '@src/types/OTC';
import {
  notifyIfDealSecurityInvalidForModify,
  notifyIfProductTemplateMissingForModify,
} from '@src/utils/OTC/notifyModifyDealGuardFailures';
import { validateInstantiatedDealSecurityForModify } from '@src/utils/OTC/validateInstantiatedDealSecurityForModify';
import type { OTCProductTemplateSecurity } from '@talos/kyoko';
import { useGlobalToasts, useSecuritiesContext } from '@talos/kyoko';
import { useCallback } from 'react';
import { getProductTemplateForDeal } from './InstrumentInspectorDrawer/shared/getProductTemplateForDeal';

const { modifyDeal } = manualDealSliceActions;

export function useModifyDeal() {
  const dispatch = useAppStateDispatch();
  const securitiesContext = useSecuritiesContext();
  const { securitiesBySymbol } = securitiesContext;
  const { add: addToast } = useGlobalToasts();

  return useCallback(
    (deal: OTCDealData) => {
      const dealSecurity = validateInstantiatedDealSecurityForModify(deal, securitiesBySymbol);
      if (!notifyIfDealSecurityInvalidForModify(deal, dealSecurity, addToast)) {
        return;
      }

      const productTemplate = getProductTemplateForDeal(deal, securitiesContext) as
        | OTCProductTemplateSecurity
        | undefined;
      if (!notifyIfProductTemplateMissingForModify(deal, productTemplate, addToast)) {
        return;
      }

      dispatch(modifyDeal({ deal, productTemplate }));
      dispatch(openManualDealTradeFormThunk({}));
    },
    [dispatch, securitiesBySymbol, securitiesContext, addToast]
  );
}
